import {
  mockPackoutConfiguratorData,
  mockRyobiConfiguratorData,
  packoutProductInfoMockData,
  ryobiProductInfoMockData
} from '../../../mock-data/configurator/packoutMockData';

/**
 * Returns true when the URL contains ?mock=true.
 * Works in browser; safely returns false during SSR.
 */
export const isMockEnabledFromUrl = () => {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return params.get('mock') === 'true' || params.get('mockData') === 'true';
};

// Product IDs that should use mock data
export const MOCK_DATA_PRODUCT_IDS = [
  338909191, // PACKOUT Wall Plate Builder
  344131957, // wall link builder
];

/**
 * Determines if a product should use mock data.
 * When ?mock=true is in the URL every product uses mock data.
 * Otherwise only the explicitly listed product IDs fall back to mock.
 * @param {string|number} productId - The external product ID
 * @returns {boolean}
 */
export const shouldUseMockData = (productId) => {
  if (isMockEnabledFromUrl()) return true;
  const numericId = typeof productId === 'string' ? parseInt(productId, 10) : productId;
  return MOCK_DATA_PRODUCT_IDS.includes(numericId);
};

/**
 * Get mock data for specific product ID
 * Extend this to support multiple mock products
 * @param {string|number} productId - The product ID
 * @returns {Object} Mock configurator data
 */
export const getMockDataByProductId = (productId) => {
  const numericId = typeof productId === 'string' ? parseInt(productId, 10) : productId;

  switch (numericId) {
  case 338909191:
    return mockPackoutConfiguratorData;
  case 344131957:
    return mockRyobiConfiguratorData;
    // Add more cases for other mock products here
    // case 123456:
    //   return anotherMockData;

  default:
    return mockPackoutConfiguratorData;
  }
};

export const getMockProductInfo = (externalProductId) => {
  const numericId = typeof externalProductId === 'string' ? parseInt(externalProductId, 10) : externalProductId;

  let info;
  switch (numericId) {
  case 338909191:
    info = packoutProductInfoMockData;
    break;
  case 344131957:
    info = ryobiProductInfoMockData;
    break;
  default:
    info = packoutProductInfoMockData;
    break;
  }

  return info;
};
/**
 * Get mock configurator data for a product
 * Simulates API call with network delay
 * @param {string|number} externalProductId - The external product ID
 * @returns {Promise} Resolves with mock data in Axios response format
 */
export const getMockConfiguratorData = (externalProductId) => {
  // Simulate network delay to mimic real API behavior
  return new Promise((resolve) => {
    setTimeout(() => {
      const mockData = getMockDataByProductId(externalProductId);

      // Return in Axios response format
      resolve({
        data: mockData,
        status: 200,
        statusText: 'OK',
        headers: {},
        config: {}
      });
    }, 300); // 300ms delay to simulate API call
  });
};
